import { ParentDashboardCard } from "@outschool/gql-backend-generated";
import { dayjs } from "@outschool/time";

import {
  CardCriteria,
  CardDefinition,
  RenderableSearchCard
} from "../CardDefinition";
import topicDefinitions from "./TopicDefinitions";

export const type = "topic";

export type TopicCardDefinition = CardDefinition & {
  criteria?: CardCriteria;
  searchFilters: { q?: string };
  title: string;
  limit?: number;
  url: string;
  imageUrl: string;
};

type TopicDefinitionSkeleton = Omit<
  TopicCardDefinition,
  "type" | "url" | "imageUrl" | "display"
> & {
  imageUrl?: string;
  display?: string;
};

export type RenderableTopicCard = RenderableSearchCard & {
  criteria?: CardCriteria;
  display?: string;
  imageUrl: string;
};

export function getRenderData(card: ParentDashboardCard) {
  const definition = definitions.find(def => def.id === card.id);
  return {
    ...definition,
    ...card
  };
}

export function getListRenderData(argument: string) {
  return definitions.find(def => def.id === argument);
}

export function makeCardDefinition(
  skeleton: TopicDefinitionSkeleton & Partial<TopicCardDefinition>,
  onlyAvailableClasses: boolean = false
): TopicCardDefinition {
  const definition = {
    type,
    imageUrl: `https://picsum.photos/seed/${skeleton.id}/300/180?blur`,
    display: null,
    url: `/dashboard/topic/${skeleton.id}`,
    ...skeleton
  };
  if (onlyAvailableClasses) {
    // @ts-ignore
    definition.searchFilters["isAvailable"] = true;
  }
  return definition;
}

function makeCardDefinitions(
  list: TopicDefinitionSkeleton[]
): TopicCardDefinition[] {
  return list.map(d => makeCardDefinition(d));
}

export const definitions: TopicCardDefinition[] =
  // @ts-expect-error
  makeCardDefinitions(topicDefinitions);

export function findWeight(
  weightsByAge: { [k: string]: number[] },
  age: number
): number {
  for (const key in weightsByAge) {
    if (weightsByAge[key].includes(age)) {
      return Number.parseInt(key);
    }
  }

  return 0;
}

export function dateFilter(topics: $TSFixMe) {
  return topics.filter((topic: $TSFixMe) => {
    const dates = topic.criteria?.dates;
    if (!dates) {
      return true;
    }
    const now = dayjs();
    if (dates.from && dayjs(dates.from).isAfter(now)) {
      return false;
    }
    if (dates.to && dayjs(dates.to).add(1, "day").isBefore(now)) {
      return false;
    }
    return true;
  });
}
